<template>
  <div>
    <b-table
      :fields="tabela.fields"
      :empty-text="$t('GERAL.NENHUM_REGISTRO')"
      responsive="sm"
      head-variant="light"
      :items="items"
      class="mt-3"
      show-empty
      striped
      hover
      @sort-changed="aoMudarOrdenacao"
    >
      <template #cell(acoes)="item">
        <div class="flex">
          <b-dropdown
            variant="outline-default"
            v-if="podeEditar || podeExcluir"
          >
            <b-dropdown-item @click="editar(item.item)" v-if="podeEditar">
              {{ $t('GERAL.EDITAR') }}
            </b-dropdown-item>
            <b-dropdown-item @click="excluir(item.item)" v-if="podeExcluir">
              {{ $t('GERAL.EXCLUIR') }}
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </template>
    </b-table>
  </div>
</template>
<script>
import Permissoes from '@/components/mixins/permissoes';
import helpers from '@/common/utils/helpers';
export default {
  mixins: [Permissoes],
  name: 'TabelaPeriodoLetivo',
  props: {
    items: {
      type: Array,
      default: Array,
    },
  },

  data() {
    return {
      tabela: {
        fields: [
          {
            key: 'ano',
            label: 'Ano letivo',
            sortable: true,
          },
          {
            key: 'dataInicio',
            label: 'Início letivo',
            sortable: true,
            formatter: (value) => {
              return helpers.formatarDataBr(value);
            },
          },
          {
            key: 'dataFim',
            label: 'Fim letivo',
            sortable: true,
            formatter: (value) => {
              return helpers.formatarDataBr(value);
            },
          },
          {
            key: 'dataInicioRematricula',
            label: 'Início rematrícula',
            sortable: true,
            formatter: (value) => {
              return helpers.formatarDataBr(value);
            },
          },
          {
            key: 'dataFimRematricula',
            label: 'Fim rematrícula',
            sortable: true,
            formatter: (value) => {
              return helpers.formatarDataBr(value);
            },
          },
          {
            key: 'statusLiberacaoDescricao',
            label: 'Status',
            sortable: true,
          },
          {
            key: 'acoes',
            label: 'Ações',
          },
        ],
      },
    };
  },
  methods: {
    editar(item) {
      this.$emit('editar', 'editar-periodo-letivo', item.id);
    },
    excluir(item) {
      this.$emit('excluir', item);
    },
    aoMudarOrdenacao({ sortBy, sortDesc }) {
      let campoOrdenado = helpers.primeiraLetraMaiuscula(sortBy)
      let ordem = sortDesc
      this.$emit('alterar-ordenacao', campoOrdenado, ordem);
    },
  },
};
</script>
